import { DomUtils } from '@zm-biz/zm-biz-utils';
import { Type } from '@zm-biz/zm-biz-utils';
import { TYPE, EMIT, NAME } from '../config';
import Alert from './main';
import Vue from 'vue';

let dialog = null;

class Dialog {
  constructor() {
    this.vm = null;
    this.initVM();
  }

  initVM() {
    let dialog = this.extendDialog();
    this.vm = new dialog().$mount();
    DomUtils.appendIf(document.body, this.vm.$el);
    this.vm.showVM({});
  }

  extendDialog() {
    Vue.component(NAME, Alert);

    let self = this;
    let dialog = Vue.extend({
      props: {
          text: '',
          type: TYPE.alert,
          show: false,
          confirm: null,
          cancel: null
      },
      methods: {
        confirmAlert() {
          self.callback(this.confirm);
        },
        confirmConfirm() {
          self.callback(this.confirm);
        },
        cancelConfirm() {
          self.callback(this.cancel);
        },
        closeTip() {
          self.callback(null);
        }
      },
      render(h) {
        let props = {
          type: this.type,
          text: this.text,
          show: this.show
        }
        let on = {}
        on[EMIT.alert] = this.confirmAlert;
        on[EMIT.cancel] = this.cancelConfirm;
        on[EMIT.confirm] = this.confirmConfirm;
        on[EMIT.tip] = this.closeTip;
        return h(NAME, { props, on });
      }
    });

    dialog.prototype.showVM = function(options) {
      this.text = options.text ? options.text : '';
      this.type = options.type ? options.type : '';
      this.confirm = options.confirm ? options.confirm : null;
      this.cancel = options.cancel ? options.cancel : null;
      this.show =  options.text ? true : false;
    };

    return dialog;
  }

  callback (fn) {
    this.vm.show = false;
    Type.isFunction(fn) ? fn() : null;
  }

  static open(options) {
    if (dialog ==null) {
      dialog = new Dialog();
    }
    dialog.vm.showVM(options);
  }
}


export default Dialog;